import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CodeItemService } from '../../common/services/codeitem.service';

@Component({
  selector: 'prg-codeitem-editor',
  templateUrl: './codeitem-base.component.html',
  styleUrls: ['./codeitem-base.component.less'],
  providers: []
})
export abstract class BaseCodeitemEditorComponent implements OnInit {

  codeitem: Observable<any>;
  displayFields: Array<string>;
  categories: Observable<Array<any>>;

  constructor(
    protected store: Store<any>,
    protected router: Router,
    protected route: ActivatedRoute,
    protected codeitemService: CodeItemService
  ) {

    this.displayFields = ['label', 'display', 'condition'];
    this.codeitem = this.store.select(s => s.advancedProgramming.codeitem);
    this.categories = this.store.select(s => s.advancedProgramming.categories);

    this.store.select(state => state.advancedProgramming.success).subscribe(
      (success: boolean) => {
        if (success) {
          setTimeout(() => {
            this.router.navigate(['../actions'], { relativeTo: this.route });
          }, 1500);
        }
      });
  }

  ngOnInit() {

    let parentId = 0;
    this.route.params.take(1).subscribe((params: any) => parentId = params.parentId);
    this.codeitemService.setParent(parentId);

    // this.route.params.forEach((params: any) => {
    //   let parentId = +params['parentId'];
    //   this.codeitemService.setParent(parentId);
    // });
  }

  protected categorySelected(category: any) {
    this.codeitemService.selectCategory(category.value);
  }

  protected deviceSelected(device: any) {
    this.codeitemService.selectDevice(device);
  }

  // protected conditionSelected(condition: any) {
  //   this.codeitemService.selectCondition(condition);
  // }

  protected doneClicked() {
    this.codeitemService.save();
  }

  protected paramsDone(event: any) {
    console.log('codeitem-condition: params done');
    this.store.select(state => state.advancedProgramming).take(1).subscribe(
      codeitem => {
        this.codeitemService.updateDisplay(codeitem.condition, 'display');
        this.codeitemService.setComplete();
      });
  }

  // protected clearCondition() {
  //   this.codeitemService.clearCondition();
  // }

  protected clearCategory() {
    this.codeitemService.clearCategory();
  }

  protected clearDevice() {
    this.codeitemService.clearDevice();
  }

  protected cancelClicked() {
    this.router.navigate(['../actions'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/codeitem-base/codeitem-base.component.ts